import { defineMessages } from 'react-intl';

export default defineMessages({
    baseCoveragesTitle: {
        id: 'tfpa.quoteandibind.wizard.residential.quote. SuccessPageOfferings.baseCoveragesTitle',
        defaultMessage: 'Property Coverages',
    },
    ho205PremiumLabel: {
        id: "quoteandbind.wizard.tfpa.residential.quote.SuccessPageOfferings.ho205Cov",
        defaultMessage: "HO-205 Office, Private School or Studio"
    }
})
